module.exports = __webpack_public_path__ + "img/leagues.d9cadbae.png";